import React from 'react';
interface ReceiptPaymentSummaryProps {
  currency: string;
  amountReceived: number;
  totalAmount: number;
  balanceDue: number;
}
export function ReceiptPaymentSummary({
  currency,
  amountReceived,
  totalAmount,
  balanceDue
}: ReceiptPaymentSummaryProps) {
  const formatAmount = (amount: number) => {
    return `${currency} ${amount.toFixed(2)}`;
  };
  return <div className="mb-8 py-6 border-t border-b border-neutral-200" data-id="element-1203">
      <div className="max-w-md mx-auto space-y-3" data-id="element-1204">
        {/* Amount Received - Large and Bold */}
        <div className="flex justify-between items-center" data-id="element-1205">
          <span className="text-base font-semibold text-neutral-700" data-id="element-1206">
            Amount Received:
          </span>
          <span className="text-2xl font-bold text-green-600" data-id="element-1207">
            {formatAmount(amountReceived)}
          </span>
        </div>

        {/* Total Amount */}
        <div className="flex justify-between items-center" data-id="element-1208">
          <span className="text-sm font-medium text-neutral-600" data-id="element-1209">
            Total Amount:
          </span>
          <span className="text-base font-medium text-neutral-900" data-id="element-1210">
            {formatAmount(totalAmount)}
          </span>
        </div>

        {/* Balance Due */}
        <div className="flex justify-between items-center pt-2 border-t border-neutral-200" data-id="element-1211">
          <span className="text-sm font-semibold text-neutral-700" data-id="element-1212">
            Balance Due:
          </span>
          <span className="text-base font-bold text-neutral-900" data-id="element-1213">
            {formatAmount(balanceDue)}
          </span>
        </div>
      </div>
    </div>;
}